class CookieService {
  getCookie(name) {
    const value = document.cookie.match(String.raw`(^|;)\s*` + name + String.raw`\s*=\s*([^;]+)`)?.pop();
    return value ? decodeURIComponent(value) : '';
  }
  setCookie(cname, cvalue, expdays, domain) {
    const d = new Date();
    d.setTime(d.getTime() + expdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + (domain ? ';domain=' + domain : '');
  }
  deleteCookie(name) {
    // Set the cookie with an expiration date in the past to delete it
    // eslint-disable-next-line unicorn/no-document-cookie
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
  }
}
export const cookieService = new CookieService();